import { render, staticRenderFns } from "./AddEditTemplate.vue?vue&type=template&id=40295b4d&scoped=true"
import script from "./AddEditTemplate.vue?vue&type=script&lang=js"
export * from "./AddEditTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40295b4d",
  null
  
)

export default component.exports